// Device-token registration API (native push only).
//
// Thin wrappers over the P1 backend endpoints. The agent + tenant are taken
// from the httpOnly session on the server — the body carries ONLY the token.
// These are called exclusively from the native push module (src/push/native.ts),
// which is guarded by Capacitor.isNativePlatform(); a normal browser never hits
// them.

import { apiFetch } from './client';

export function registerPushToken(token: string): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>('/push/register', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });
}

export function unregisterPushToken(token: string): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>('/push/unregister', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });
}
